"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyObject = void 0;
const functions_1 = require("./functions");
const WrappedPropertyBase_1 = require("./WrappedPropertyBase");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const defaultValue_1 = require("../JSchema/defaultValue");
const fixDateFormat_1 = require("../JSchema/fixDateFormat");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
const setData_1 = require("../JSchema/setData");
const setNewData_1 = require("../JSchema/setNewData");
const deepCopy_1 = require("../methods/deepCopy");
class WrappedPropertyObject extends WrappedPropertyBase_1.WrappedPropertyBase {
    constructor(props) {
        super(props, (internal) => {
            internal.schemaprops = props.schema.properties;
            internal.cacheProp = {};
        });
        /**
         * odwiedzone pola
         */
        this.$visitedProps = [];
        const internal = this._internal;
        let mparent = internal.mparent;
        // initVue(this, this._internal);
        if (internal.schemaprops) {
            if (mparent === undefined) {
                const defvalue = (0, defaultValue_1.defaultValue)(props.schema, true, undefined, this._internal.options, this.$path);
                props.parent[props.propName] = defvalue;
                internal.mparent = mparent = props.parent[props.propName];
            }
            // tworzenie property
            // if (mparent != null) {
            createProps(this, internal, internal.options);
            /*
            const required: any = schema.required || [];
            for (const key in internal.schemaprops) {
              if (internal.schemaprops.hasOwnProperty(key)) {
                const element = internal.schemaprops[key];
                if ((element.fieldRequired === undefined) && (required.indexOf(key) > -1)) {
                  element.fieldRequired = true;
                }
                let type = element.type;
      
      
      
                // setTimeout(function() {
                // self.wrapProperty(obj, mparent, key, element);
      
                // let proptime = (new Date()).getTime();
                if (this._options.wrapAll) {
                  const prop: IWrappedProperty = (this[key] = new Ctor[type](this, mparent, key, element, options));
                  if (this.$dirty) {
                    prop.$dirty = true;
                  }
                } else {
                  Object.defineProperty(this, key, {
                    enumerable: true,
                    get() {
                      let prop = internal.cacheProp[key];
                      if (prop === undefined) {
      
                        prop = internal.cacheProp[key] = new Ctor[type](this, mparent, key, element, options);
                        if (this.$dirty) {
                          prop.$dirty = true;
                        }
                      }
                      return prop;
                    }
                  });
      
                  // console.log('prop time 1', key, (new Date()).getTime() - proptime);
      
                  // trzeba utworzyć tabele jeśli są undefined w modelu
      
                  if (type === 'array' || mparent[key] === undefined || anyCalc(element)) {
                    const prop = internal.cacheProp[key] = new Ctor[type](this, mparent, key, element, options);
                    if (this.$dirty) {
                      prop.$dirty = true;
                    }
                  }
                }
      
                // console.log('prop time', key, (new Date()).getTime() - proptime);
              }
            }
            */
            // }
        }
    }
    /**
     * ustawienie wartości wmodelu
     *
     * @param {*} value nowa wartość
     * @param {string} [path] ścieżka gdy ustawiany jest element podrżedny
     * @param {boolean} [fixArraySize] czy ustawiać nową dłguośc tablicy
     * @returns {boolean}
     * @memberof WrappedPropertyObject
     */
    $setData(value, path, fixArraySize) {
        var _a, _b;
        // wymus reactive jest to jest root
        /*
        if (!this._internal.parent && value && !isReactive(value)) {
          value = reactive(value)
    
        }
        */
        if (path) {
            return (0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._options, this.$path);
        }
        else {
            let prevValue = undefined;
            if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.beforeChange) {
                if (prevValue === undefined)
                    prevValue = (0, deepCopy_1.deepCopy)(this.$model);
                //if (newValue !== prevValue) {
                const event = { type: 'beforeChange', target: this, value, prevValue };
                if ((0, functions_1.runEvent)(event)) {
                    value = event.value;
                }
                //}
            }
            if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.change) {
                if (prevValue === undefined)
                    prevValue = (0, deepCopy_1.deepCopy)(this.$model);
                if ((0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._options, this.$path)) {
                    // console.log('$setData', this.$path, value);
                    // if (prevValue !== value)
                    (0, functions_1.runEvent)({ type: 'change', target: this, value, prevValue });
                    return true;
                }
                return false;
            }
            else {
                return (0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._options, this.$path);
            }
        }
    }
    $setNewData(value, path) {
        return (0, setNewData_1.setNewData)(this._internal.schema, this.$model, value, path, 0, this._options, this.$path);
    }
    get $diffStatus() {
        if (this._internal.prevModel === undefined) {
            return 'new';
        }
        return '';
    }
    $getInvalidValues(res = []) {
        if (this._internal.cacheProp) {
            for (const key in this._internal.cacheProp) {
                const prop = this._internal.cacheProp[key];
                prop.$getInvalidValues(res);
            }
        }
        return res;
    }
    $setInvalidValues(res) {
        for (let i = 0; i < res.length; i++) {
            const child = this.$child(res[i].$path, true);
            if (child) {
                child.$value = res[i].$value;
                child.$dirty = true;
            }
        }
    }
    /**
     * sprawdza obiekt pod kątem błedów
     *
     * @param {*} [value] wejściowy obiekt
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} komunikat błędu lub null gdy błedu nie ma
     * @memberof WrappedPropertyObject
     */
    $validate(value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        /*
        if (!this.$parent) {
          // self.startDirty = true;
          this._internal.options.startDirty = true;
        }
        */
        if (value === undefined) {
            value = this.$model;
        }
        if (value === null) {
            // console.timeEnd('(number)$validate');
            if (this.$schema.fieldRequired) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message,
                    expected: true
                };
                return message;
            }
            return null;
        }
        return null;
        /*
            if (value === undefined) {
                value = mparent;
            }
            */
    }
    /**
     * sprawdza obiekt i wszystkie jego elementy pod kątem błędów
     *
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista elementów zawierających błedy
     * @memberof WrappedPropertyObject
     */
    $validateAll(skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$disabled) {
            return result;
        }
        if (this.$validate(undefined, skipDirty) !== null) {
            result.push(this);
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        // tslint:disable-next-line: forin
        for (const key in this._internal.schemaprops) {
            const item = this[key];
            if (item) {
                item.$validateAll(skipDirty, result);
            }
        }
        return result;
    }
    /**
     * sprawdza obiekt pod kątem ostrzeżeń
     *
     * @param {*} [value] obiekt
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyObject
     */
    $check(value, skipDirty /*, checkResult?: []*/) {
        if (!this.$disabled) {
            if (!skipDirty) {
                this.$dirty = true;
            }
            if (!this.$parent) {
                // self.startDirty = true;
                this._internal.options.startDirty = true;
            }
        }
        return (this.$checkResult = []);
    }
    /**
     * sprawdza obiekt i wszystkie jego elementy pod kątem ostrzeżeń
     *
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista pól zawierających ostrzeżenia
     * @memberof WrappedPropertyObject
     */
    $checkAll(skipDirty, result) {
        if (this.$disabled) {
            return [];
        }
        if (result === undefined) {
            result = [];
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        for (const key in this._internal.schemaprops) {
            if (this[key]) {
                this[key].$checkAll(skipDirty, result);
            }
        }
        return result;
    }
    /**
     * czyści status $dirty na wszystkich właściwościach obiektu
     *
     * @memberof WrappedPropertyObject
     */
    $reset() {
        // tslint:disable-next-line: forin
        for (const key in this._internal.cacheProp) {
            const prop = this._internal.cacheProp[key];
            if (prop !== undefined) {
                prop.$reset();
            }
        }
        this.$dirty = false;
        if (!this.$parent) {
            this._internal.options.startDirty = false;
            this._internal.options._userInput = false;
        }
    }
    /**
     * list elementów "dotkniętych" przez użytkownika
     *
     * @param {any[]} result
     * @returns {any[]}
     * @memberof WrappedPropertyObject
     */
    $dirtyList(result) {
        if (result === undefined) {
            result = [];
        }
        // pomijaj pola $disabled
        if (this.$schema.disabled)
            return result;
        // tslint:disable-next-line: forin
        for (const key in this._internal.cacheProp) {
            const prop = this._internal.cacheProp[key];
            if (prop) {
                prop.$dirtyList(result);
            }
        }
        return result;
    }
    /**
     * naprawia format daty we wszytkich właściwościach obiektu
     *
     * @returns {number}
     * @memberof WrappedPropertyObject
     */
    $fixDateFormat() {
        return (0, fixDateFormat_1.fixDateFormat)(this._internal.schema, this.$model);
    }
    $fixFormat() {
        return (0, fixDateFormat_1.fixDateFormat)(this._internal.schema, this.$model);
    }
    $traverseFirst(predicate, allProps) {
        if (allProps) {
            if (predicate(this))
                return this;
            //for (const key in internal.schemaprops) {
            for (const key in this._internal.schemaprops) {
                const prop = this[key];
                if (prop) {
                    const res = prop.$traverseFirst(predicate, !!allProps);
                    if (res) {
                        return res;
                    }
                }
            }
        }
        else {
            if (this.$schema.disabled)
                return undefined;
            if (predicate(this))
                return this;
            for (const key in this._internal.cacheProp) {
                const prop = this._internal.cacheProp[key];
                const res = prop.$traverseFirst(predicate, !!allProps);
                if (res) {
                    return res;
                }
            }
        }
    }
    /**
     * pobranie wszystkich pól
     */
    get $fields() {
        if (this._options.wrapAll) {
            return this._internal.cacheProp;
        }
        const result = {};
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        for (const key in this._internal.schema.properties) {
            if (this._internal.cacheProp[key]) {
                result[key] = this._internal.cacheProp[key];
            }
            else {
                Object.defineProperty(result, key, {
                    enumerable: true,
                    configurable: true, // zeby można było usuwać
                    //configurable: false, // zeby nie obudowywac Vue
                    get() {
                        return self[key];
                    }
                });
            }
        }
        return result;
    }
    /**
     * niszczenie obiektu i zwalnianie zasobów
     *
     * @memberof WrappedPropertyObject
     */
    $destroy() {
        // debugger;
        removeProps(this, this._internal, this._options, !Object.isSealed(this));
        super.$destroy();
    }
    $addProp(key, propSchema) {
        const cprop = this._internal.cacheProp[key];
        if (cprop) {
            cprop.$destroy();
            delete this._internal.cacheProp[key];
            delete this[key];
        }
        this._internal.schemaprops[key] = propSchema;
        createProp(key, this, this._internal, this._options);
        return this[key];
    }
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyObject
     */
    beforePathChange() {
        super.beforePathChange();
        // tslint:disable-next-line: forin
        for (const key in this._internal.cacheProp) {
            const prop = this._internal.cacheProp[key];
            if (prop) {
                prop.beforePathChange();
            }
        }
    }
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyObject
     */
    afterPathChange() {
        // tslint:disable-next-line: forin
        for (const key in this._internal.cacheProp) {
            const prop = this._internal.cacheProp[key];
            if (prop) {
                prop.afterPathChange();
            }
        }
        super.afterPathChange();
    }
}
exports.WrappedPropertyObject = WrappedPropertyObject;
/**
 * funkcja do tworzenie property na podstawie schematu
 *
 * @param {WrappedPropertyObject} obj
 * @param {IObjectInternal} internal
 * @param {IOptions} options
 * @returns
 */
function createProps(obj, internal, options) {
    for (const key in internal.schemaprops) {
        createProp(key, obj, internal, options);
    }
}
function createProp(key, obj, internal, options) {
    const element = internal.schemaprops[key];
    const required = internal.schema.required || [];
    let mparent = internal.mparent;
    if (element.fieldRequired === undefined && required.indexOf(key) > -1) {
        element.fieldRequired = true;
    }
    const type = element.type || (element.type = (element.properties && 'object') || (element.items && 'array') || 'string');
    const isRoot = obj.$parent === null;
    if (options.wrapAll) {
        internal.cacheProp[key] = new WrappedPropertyCtor_1.WrappedPropertyCtor[type]({
            dest: obj,
            parent: mparent,
            prevModel: internal.prevModel ? internal.prevModel[key] : undefined,
            propName: key,
            schema: element,
            options
        });
    }
    if (options.wrapAll && !isRoot) {
        const prop = (obj[key] = internal.cacheProp[key]);
        if (obj.$data['$dirty'] && !prop.$disabled) {
            prop.$dirty = true;
        }
        // Object.seal(prop);
    }
    else {
        Object.defineProperty(obj, key, {
            enumerable: true,
            configurable: true, // zeby można było usuwać
            //configurable: false, // zeby nie obudowywac Vue
            get() {
                let prop = internal.cacheProp[key];
                // tslint:disable-next-line: no-conditional-assignment
                if ((mparent = obj.$model) === null) {
                    if (prop) {
                        prop.$destroy();
                        delete internal.cacheProp[key];
                        if (this.$parent === null) {
                            const visitedIndex = obj.$visitedProps.indexOf(prop);
                            if (visitedIndex > -1) {
                                obj.$visitedProps = obj.$visitedProps.splice(visitedIndex, 1);
                            }
                        }
                    }
                    return null;
                }
                if (prop === undefined) {
                    prop = internal.cacheProp[key] = new WrappedPropertyCtor_1.WrappedPropertyCtor[type]({
                        dest: obj,
                        parent: mparent,
                        prevModel: internal.prevModel ? internal.prevModel[key] : undefined,
                        propName: key,
                        schema: element,
                        options
                    });
                    if (obj.$data['$dirty'] && !prop.$disabled) {
                        prop.$dirty = true;
                    }
                }
                // register get on root
                if (isRoot) {
                    const visitedIndex = obj.$visitedProps.indexOf(prop);
                    if (visitedIndex == -1) {
                        obj.$visitedProps.push(prop);
                    }
                }
                // Object.seal(prop);
                return prop;
            }
        });
        // console.log('prop time 1', key, (new Date()).getTime() - proptime);
        // trzeba utworzyć tabele jeśli są undefined w modelu
        if (mparent && internal.cacheProp[key] === undefined) {
            if (type === 'array' || mparent[key] === undefined || (0, functions_1.anyCalc)(element)) {
                const prop = (internal.cacheProp[key] = new WrappedPropertyCtor_1.WrappedPropertyCtor[type]({
                    dest: obj,
                    parent: mparent,
                    prevModel: internal.prevModel ? internal.prevModel[key] : undefined,
                    propName: key,
                    schema: element,
                    options
                }));
                //  obj, mparent, key, element, options));
                if (obj.$dirty && !prop.$disabled) {
                    prop.$dirty = true;
                }
            }
        }
    }
}
/**
 * funkcja usuwania wszystkich property
 *
 * @param {WrappedPropertyObject} obj
 * @param {IObjectInternal} internal
 * @param {IOptions} options
 */
function removeProps(obj, internal, options, removeFromObj) {
    // const mparent = internal.mparent;
    // const schema = internal.schema;
    // const required: any = schema.required || [];
    for (const key in internal.schemaprops) {
        const cprop = internal.cacheProp[key];
        if (cprop) {
            cprop.$destroy();
            delete internal.cacheProp[key];
            if (removeFromObj) {
                delete obj[key];
            }
        }
        // console.log('prop time', key, (new Date()).getTime() - proptime);
    }
}
WrappedPropertyCtor_1.WrappedPropertyCtor.object = WrappedPropertyObject;
exports.default = WrappedPropertyObject;
//# sourceMappingURL=WrappedPropertyObject.js.map